<template>
  <lf-dropdown
    :value="value ?? '-'"
    :name="name"
    :options="options"
    :disabled="disabled"
    :is-loading="isLoading"
    as-badge
    menu-width="w-48"
    full-width
    search-enabled
    @change="emit('update:status', $event)"
  >
    <template #toggle-button="{ toggle, menuOpen }">
      <button
        type="button"
        class="relative flex max-w-33 min-w-10 cursor-pointer justify-between rounded-full py-1 pl-3 text-left text-xs font-semibold uppercase"
        :style="styles"
        :data-cy="name"
        @click="!disabled && toggle()"
      >
        <span
          ref="statusRef"
          v-tooltip="{
            content: value,
            onShow: () => isStatusTruncated,
          }"
          class="max-w-32 truncate"
        >
          {{ value ?? "-" }}
        </span>
        <span
          v-if="!disabled"
          class="inset-y-0 flex cursor-pointer place-self-center"
          :class="{
            'px-2': menuOpen && !disabled,
            'ml-2 pr-2': !menuOpen && !disabled,
            'pr-4': disabled,
          }"
        >
          <icon-base
            height="6"
            width="10"
            :icon="IconDropdownArrow"
            :class="[
              'transform transition-transform',
              menuOpen ? 'rotate-180' : 'rotate-0',
            ]"
          />
        </span>
      </button>
    </template>
  </lf-dropdown>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";

import { useElementStatus } from "@/hooks/elements";

import IconDropdownArrow from "@/components/icons/IconDropdownArrow.vue";
import LfDropdown from "@/components/ui/inputs/LfDropdown.vue";

const props = withDefaults(
  defineProps<{
    value: string | null;
    name: string;
    options: Record<string, string>;
    color?: string;
    isLoading?: boolean;
    disabled?: boolean;
  }>(),
  { color: "#888e9d" }
);

const { isTextTruncated } = useElementStatus();

const statusRef = ref<HTMLElement | null>(null);
const isStatusTruncated = isTextTruncated(statusRef);

const emit = defineEmits<{
  "update:status": [string | number];
}>();
const styles = computed(() => ({
  backgroundColor: props.color + "10",
  color: props.color,
}));
</script>
